/**
 * @fileoverview Detects thread history load failures caused by HTTP 404 (stale or missing thread).
 * @ownership @korvo/core
 */

import { KorvoError } from './korvo-error';

type ErrorWithStatus = Error & { status?: number };

export function parseThreadsClientHttpStatus(error: unknown): number | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }
  const status = (error as ErrorWithStatus).status;
  if (typeof status === 'number' && Number.isFinite(status)) {
    return status;
  }
  if (error instanceof Error && /\b404\b/.test(error.message)) {
    return 404;
  }
  return undefined;
}

export function isThreadHistoryNotFoundError(error: unknown): boolean {
  if (parseThreadsClientHttpStatus(error) === 404) {
    return true;
  }
  if (error instanceof KorvoError) {
    const msg = error.message;
    if (typeof msg === 'string' && /\b404\b/.test(msg)) {
      return true;
    }
  }
  if (error instanceof Error && /Failed to get messages:\s*404/.test(error.message)) {
    return true;
  }
  return false;
}
